export default __webpack_public_path__ + "static/Gellix-Medium-0a1a9f95af5efa29d2d30404334796c9.woff2";